import React from 'react';
import styled from '@benzinga/themetron';
import { News } from '@benzinga/basic-news-manager';
import { H2 } from '@benzinga/core-ui';

export interface NewsFeaturedSectionProps {
  attrs: {
    data?: {
      title?: string;
      page_action_link?: string;
      page_action_link_text?: string;
    };
  };
}

export const PageTitleBlock: React.FC<NewsFeaturedSectionProps> = ({ attrs }) => {
  const title = attrs?.data?.title;
  const pageActionLink = attrs?.data?.page_action_link;
  const pageActionText = attrs?.data?.page_action_link_text;

  if (!title) return <div />;

  return (
    <PageTitleWrapper className="page-title-wrapper">
      <PageTitle className="page-title">{title}</PageTitle>
      <PageAction href={pageActionLink}>{pageActionText}</PageAction>
    </PageTitleWrapper>
  );
};

export const PageTitle = styled(H2)`
  &.page-title {
    font-size: 2.6rem;
    color: #111;
  }
`;

export const PageTitleWrapper = styled.div`
  &.page-title-wrapper {
    display: inline-flex;
    margin-bottom: 0.75rem;
    align-items: baseline;
    border-bottom: solid 1px ${({ theme }) => theme.colorPalette.neutral500};
    padding-bottom: 0.25rem;
    width: 100%;
    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
`;

export const PageAction = styled.a`
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-style: italic;
`;
